import sharedStore from "@shared/authentication/vuex/authentication.module";
import { currentUser } from "@/api/current.user.api";

const state = {
	...sharedStore.state
};
const getters = {
	...sharedStore.getters
};
const actions = {
	...sharedStore.actions,
	async login({ commit, dispatch }, details) {
		commit("LOAD_START");
		const user = await currentUser.login(details).catch((error) => {
			commit("MESSAGE_FAILURE", error.response.data.error);
		});
		if (user) {
			dispatch("userModule/set", user, { root: true });
			commit("MESSAGE_SUCCESS");
		}
	}
};

const mutations = {
	...sharedStore.mutations
};

export default { namespaced: true, state, getters, actions, mutations };
